import columnsByGroup from './columnsByGroup'

export default [
  {
    label: 'Centro',
    name: 'distributionCenter',
  },
  ...columnsByGroup,
]
